import React, { Component } from "react";
import { ConstantBasedPicker } from "@openimis/fe-core";

import { INSUREE_ACTIVE } from "../constants";

class insureeActivePicker extends Component {

    render() {
        const { readOnly = false, required = false, withNull = true, nullLabel = null } = this.props;
        
        return <ConstantBasedPicker
            module="scheme"
            label="Beneficiary Status"
            constants={INSUREE_ACTIVE}
            readOnly={readOnly}
            {...this.props}
        />
    }
}

export default insureeActivePicker;